import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ACH_TRANSFERS_HISTORY } from "../../../api/queryKeys";
import { QueryAchTransferHistoryResponse } from "../../../types";

export const getAchData = () =>
  api
    .get<QueryAchTransferHistoryResponse>(QUERY_ACH_TRANSFERS_HISTORY)
    .then((res) => res.data);

export default function useGetAchTransfers() {
  return useQuery([QUERY_ACH_TRANSFERS_HISTORY], getAchData);
}
